export const GLOBAL_STATE = 'ReservationRoom'

export const RESERVATION_ROOM = 'RESERVATION_ROOM' as const
export const RESERVATION_ROOM_CREATE = 'RESERVATION_ROOM_CREATE' as const
export const RESERVATION_ROOM_ALL = 'RESERVATION_ROOM_ALL' as const
export const RESERVATION_ROOM_LIST = 'RESERVATION_ROOM_LIST' as const
export const RESERVATION_ROOM_DELETE = 'RESERVATION_ROOM_DELETE' as const
export const RESERVATION_TIME_SLOT_ALL = 'RESERVATION_TIME_SLOT_ALL' as const
export const ROOM_RESERVATION = 'ROOM_RESERVATION' as const
export const ROOM_RESERVATION_ALL = 'ROOM_RESERVATION_ALL' as const
export const ROOM_RESERVATION_DELETE = 'ROOM_RESERVATION_DELETE' as const
